import { ThemeOptions, createTheme } from '@material-ui/core/styles';
import {
  NeueHaasGrotBold,
  NeueHaasGrotBoldItalic,
  NeueHaasGrotLight,
  NeueHaasGrotLightItalic,
  NeueHaasGrotMedium,
  NeueHaasGrotMediumItalic,
} from './fonts';
import { grey } from '@material-ui/core/colors';
declare module '@material-ui/core/styles/createPalette' {
  interface TypeBackground {
    default: string;
    paper: string;
    navigation: string;
    secondary: string;
  }
  interface TypeText {
    navigation: string;
    navigationSecondary: string;
    main: string;
  }
}

export const colors = {
  modernMagenta: '#FF006B',
  innuendoPink: '#FA89BB',
  pastelGreen: '#58DEB8',
  cyberBeach: '#EF9D6F',
  darkPlum: '#2F1327',
  almostHuman: '#F5E8E1',
  lightGrey: '#f1f1f1',
  offWhite: '#F5F5F5',
  white: '#fff',
  black: '#000',
};

const fontFamily = ['Haas Grot', 'Helvetica', 'sans-serif'].join(',');

const palette: ThemeOptions['palette'] = {
  primary: {
    main: colors.darkPlum,
    light: colors.innuendoPink,
  },
  secondary: {
    main: colors.darkPlum,
  },
  background: {
    paper: colors.white,
    default: colors.almostHuman,
    navigation: colors.darkPlum,
    secondary: colors.offWhite,
  },
  text: {
    primary: colors.black,
    secondary: '#BABABA',
    navigation: colors.white,
    navigationSecondary: colors.white,
    hint: colors.cyberBeach,
  },
  action: {
    active: colors.innuendoPink,
    hover: colors.innuendoPink,
    disabled: '#BCBCBC',
  },
  info: {
    main: colors.pastelGreen,
  },
  error: {
    main: '#D3302F',
  },
  divider: '#4D4D4D',
};

export const newTheme = createTheme({
  palette,
  typography: {
    fontFamily: fontFamily,
    h6: {
      fontWeight: 600,
      fontSize: '16px',
    },
  },
  customProps: {
    inactiveOpacity: 1,
    header: {
      backgroundColor: '#f1f1f1',
      borderBottom: `1px solid ${grey[500]}`,
      textColor: '#000',
    },
    tabs: {
      bottomBorder: `4px solid #B3B3B3 `,
      activeBackgroundColor: '#dbdbdb',
      backgroundColor: '#f1f1f1',
      textColor: '#000',
    },
    table: {
      fontSize: 16,
    },
    backgroundColor: colors.almostHuman,
    actionColor: colors.modernMagenta,
  },
  overrides: {
    MuiButtonBase: {
      root: {
        // to make tabs text above tabs indicator
        zIndex: 1,
      },
    },
    MuiTab: {
      root: {
        textTransform: 'none',
      },
      textColorInherit: {
        opacity: 1,
      },
    },
  },
});
